import { render, staticRenderFns } from "./store-step.vue?vue&type=template&id=6f5a783e&scoped=true"
import script from "./store-step.vue?vue&type=script&lang=js"
export * from "./store-step.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f5a783e",
  null
  
)

export default component.exports